var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "google_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.373 24 0 18.627 0 12 0 5.372 5.373 0 12 0c6.628 0 12 5.372 12 12 0 6.627-5.372 12-12 12",
  fill: "#231F20",
  mask: "url(#google_svg__a)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.26 10.434h-6.757v2.802h3.89c-.195.956-.724 1.69-1.482 2.168-.654.412-1.477.634-2.408.634a4.288 4.288 0 0 1-4.068-5.632 4.275 4.275 0 0 1 4.068-2.939c1.022 0 1.945.363 2.67.956l2.11-2.11c-1.286-1.12-2.934-1.813-4.78-1.813A7.224 7.224 0 0 0 6 8.544a7.243 7.243 0 0 0-.002 6.415 7.224 7.224 0 0 0 6.505 4.046c1.768 0 3.455-.632 4.723-1.81 1.331-1.237 2.2-3.078 2.2-5.442 0-.43-.066-.89-.166-1.32",
  fill: "#FFF"
}))));
export default SvgGoogle;